import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { supabase } from './lib/supabase'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import { VaultProvider } from './contexts/VaultContext'

// Components
import ErrorBoundary from './components/ErrorBoundary'
import LoadingScreen from './components/LoadingScreen'
import AuthPage from './pages/AuthPage'
import VaultPage from './pages/VaultPage'

function AppContent() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingScreen />
  }

  return (
    <div className="min-h-screen">
      <Routes>
        <Route 
          path="/auth" 
          element={user ? <Navigate to="/vault" replace /> : <AuthPage />} 
        />
        <Route 
          path="/vault" 
          element={user ? <VaultPage /> : <Navigate to="/auth" replace />} 
        />
        <Route 
          path="/" 
          element={<Navigate to={user ? "/vault" : "/auth"} replace />} 
        />
      </Routes>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#fff',
            color: '#374151',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: '1px solid #e5e7eb',
            borderRadius: '0.75rem',
          },
        }}
      />
    </div>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <VaultProvider>
            <AppContent />
          </VaultProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  )
}

export default App
